import {useCallback, useState} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import {RestartAlt} from '@mui/icons-material';
import {apiPost} from '../../../axiosConfig';
import DialogApiRequestStatus from '../../../components/dialogs/DialogApiRequestStatus';

const ReTriggerBmStingerTask = ({
  company,
  isIcon = false,
}: {
  company: {id: number; name: string};
  isIcon?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const [apiState, setApiState] = useState({
    status: '',
    error: null,
    message: '',
  });

  const closeDialog = useCallback(() => {
    setOpen(false);
  }, []);

  const resetApiState = useCallback(() => {
    setApiState({status: '', error: null, message: ''});
  }, []);

  const handleSubmit = useCallback(() => {
    setApiState({status: 'pending', error: null, message: ''});
    apiPost(`v1/company/${company.id}/re-trigger-bm-stinger-task`, {})
      .then(response => {
        setOpen(false);
        setApiState({
          status: 'success',
          error: null,
          message: response?.data?.message ?? '',
        });
      })
      .catch(error => {
        setApiState({status: 'error', error, message: ''});
      });
  }, [company.id]);

  return (
    <>
      {isIcon ? (
        <IconButton
          color='warning'
          size='small'
          title='Re-trigger BM & Stinger'
          aria-label='re-trigger bm & stinger'
          onClick={() => setOpen(true)}>
          <RestartAlt />
        </IconButton>
      ) : (
        <Button
          disableElevation
          variant='contained'
          color='warning'
          onClick={() => setOpen(true)}>
          Re-trigger BM & Stinger
        </Button>
      )}

      {open && (
        <Dialog maxWidth='sm' fullWidth open onClose={closeDialog}>
          <DialogTitle>
            <Typography>Confirmation</Typography>
          </DialogTitle>
          <DialogContent>
            <Typography variant='h6' fontWeight='bold' color='warning'>
              You are about to re-trigger the Create BM and Stinger task for{' '}
              {company.name}
            </Typography>
            <Typography className='mt-3'>Are you sure to proceed?</Typography>
          </DialogContent>
          <DialogActions>
            <Button variant='contained' onClick={handleSubmit}>
              Re-trigger
            </Button>
            <Button color='secondary' onClick={closeDialog} variant='contained'>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {apiState.status !== '' && (
        <DialogApiRequestStatus
          apiState={apiState}
          onRetry={handleSubmit}
          onEdit={resetApiState}
          onClose={resetApiState}
        />
      )}
    </>
  );
};

export default ReTriggerBmStingerTask;
